var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('PageHeader',{attrs:{"label":"Uploading to Mercury"}}),_c('div',{staticClass:"mt-8"},[_vm._v("\n    Uploading...\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }